import React, { useState, useMemo } from 'react';
import './MobilePeopleList.css';

function MobilePeopleList({ donors, onSelectPerson }) {
  const [searchQuery, setSearchQuery] = useState('');

  // Avatar colors based on name (cool colors only)
  const getAvatarColor = (name) => {
    const colors = [
      '#a78bfa', // purple
      '#4ade80', // green
      '#60a5fa', // blue
      '#34d399', // teal
      '#818cf8', // indigo
      '#2dd4bf', // cyan
      '#22d3d1', // aqua
      '#10b981', // emerald
    ];
    const index = name ? name.charCodeAt(0) % colors.length : 0;
    return colors[index];
  };

  // Get initials from name
  const getInitials = (name) => {
    if (!name) return '??';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  // Convert donors object to sorted array (by recency)
  const donorList = useMemo(() => {
    const list = Object.entries(donors || {}).map(([name, data]) => ({
      name,
      ...data
    }));

    // Sort by last contact (most recent first)
    return list.sort((a, b) => {
      const dateA = a.lastContact ? new Date(a.lastContact) : new Date(0);
      const dateB = b.lastContact ? new Date(b.lastContact) : new Date(0);
      return dateB - dateA;
    });
  }, [donors]);

  // Filter by search query
  const filteredDonors = useMemo(() => {
    if (!searchQuery.trim()) return donorList;

    const query = searchQuery.toLowerCase();
    return donorList.filter(donor =>
      donor.name.toLowerCase().includes(query)
    );
  }, [donorList, searchQuery]);

  // Build context string for each donor
  const getContextString = (donor) => {
    // Show amount if available
    if (donor.amount && donor.amount !== 'Unknown') {
      return donor.amount + ' prospect';
    }
    return null;
  };

  return (
    <div className="mobile-people-list">
      {/* Search bar */}
      <div className="people-search-container">
        <div className="people-search-box">
          <span className="people-search-icon">⌕</span>
          <input
            type="text"
            className="people-search"
            placeholder="Search people..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              className="people-search-clear"
              onClick={() => setSearchQuery('')}
            >
              ×
            </button>
          )}
        </div>
      </div>

      {/* People list */}
      <div className="people-scroll">
        {filteredDonors.length === 0 ? (
          <div className="people-empty">
            {searchQuery ? (
              <>No people matching "{searchQuery}"</>
            ) : (
              <>No people yet</>
            )}
          </div>
        ) : (
          filteredDonors.map(donor => (
            <div
              key={donor.name}
              className="people-row"
              onClick={() => onSelectPerson(donor)}
            >
              <div
                className="people-row-avatar"
                style={{ borderColor: getAvatarColor(donor.name), color: getAvatarColor(donor.name) }}
              >
                {getInitials(donor.name)}
              </div>
              <div className="people-row-info">
                <div className="people-row-name">{donor.name}</div>
                {getContextString(donor) && (
                  <div className="people-row-context">
                    {getContextString(donor)}
                  </div>
                )}
              </div>
              <div className="people-row-arrow">›</div>
            </div>
          ))
        )}
      </div>

    </div>
  );
}

export default MobilePeopleList;
